import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";
import api from "../../../../../../../api";
import urls from "../../../../../../../urls";
import type { DataGaps } from "../../../../../../../utils/backend-types";
import { luxonDateTimeToBackendDateOrDateTime } from "../../../../../../../utils/dates/luxonDateTimeToBackendDateOrDateTime";

async function getLocationDataGaps(locationId: number, start: Date, end: Date) {
  const firstDateStr = luxonDateTimeToBackendDateOrDateTime(
    DateTime.fromJSDate(start).startOf("day"),
    "ISO 8601"
  );
  const lastDateStr = luxonDateTimeToBackendDateOrDateTime(
    DateTime.fromJSDate(end).endOf("day"),
    "ISO 8601"
  );

  const response = await api.get<DataGaps>(
    urls.api.locationDataGaps(firstDateStr, lastDateStr, locationId)
  );

  return response.data;
}

function useLocationDataGaps(
  type: string,
  locationId: number,
  start: Date,
  end: Date
) {
  const { isLoading, error, data } = useQuery<DataGaps>({
    queryKey: ["locationDataGaps", { locationId, start, end }],
    queryFn: () => getLocationDataGaps(locationId, start, end),
    retry: false,
    enabled: type === "location" && !!locationId
  });

  return {
    isLoading,
    error,
    locationDataGaps: data
  };
}

export { useLocationDataGaps };
